var App = App || {};

App.WidgetFaq = (function ($) {
    'use strict';

    function Animate(widget) {
        const animate = widget.find(".accordion");
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".accordion-item", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    function Accordion(widget) {

        const accordions = widget.find(".accordion");
        const accordionCollapse = widget.find(".accordion-collapse");

        accordions.each(function () {

            const accordion = $(this);
            const component = $(this).parents(".widget[class*='widget-faq']");
            const viewMore = component.find(`button[aria-controls=\"${accordion.attr("id")}\"]`);

            viewMore.on("click", function () {
                if ($(this).attr("aria-expanded") == "false") {
                    $(this).attr("aria-expanded", "true").text("View Less");
                    accordion.find(".accordion-item.d-none").addClass("accordion-item-conditional").removeClass("d-none");
                }
                else if ($(this).attr("aria-expanded") == "true") {
                    $(this).attr("aria-expanded", "false").text("View More");
                    accordion.find(".accordion-item.accordion-item-conditional").removeClass("accordion-item-conditional").addClass("d-none");
                }
            });
        });

        accordionCollapse.each(function () {

            const collapse = $(this);
            const indicator = $(this).parents(".accordion-item").find(".accordion-button .indicator > span");

            collapse.on("hide.bs.collapse", function () {
                indicator.text("Show")
            })

            collapse.on("show.bs.collapse", function () {
                indicator.text("Hide")
            })

        });


    }

    return {
        Animate: Animate,
        Accordion: Accordion
    };

})(jQuery);